module.exports = __webpack_public_path__ + "static/media/invoice-weather.e4f358b1.svg";